/**
 * @module media/mediastyle
 */
import { Plugin } from '@ckeditor/ckeditor5-core';
import MediaStyleEditing from './mediastyle/mediastyleediting';
import './theme/mediastyle.css';

export default class MediaStyle extends Plugin {
    /**
     * @inheritDoc
     */
    static get requires() {
        return [MediaStyleEditing];
    }
    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'MediaStyle';
    }
}
//# sourceMappingURL=mediastyle.js.map